import React from 'react';
import {Show, SimpleShowLayout, TextField} from 'react-admin';

const ProjectShow = (props) => (
    <Show{...props}>
        <SimpleShowLayout>
            <TextField label="Nom" source="project_name"/>
            <TextField label="Établissement" source="establishment"/>
            <TextField label="Identité" source="contact_identity"/>
            <TextField label="Tél" source="contact_tel"/>
            <TextField label="Mail" source="contact_email"/>
            <TextField label="Montant" source="amount_project"/>
            <TextField label="Description" source="description"/>
            <TextField label="Création" source="creation_date"/>
        </SimpleShowLayout>
    </Show>
)

export default ProjectShow;
